import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { FIND_ROUTE_PATHS } from './config';

export const FIND_ROUTES: TApplicationRoute[] = [
  {
    id: 'find-users',
    path: FIND_ROUTE_PATHS.findUser,
    component: lazy(() => import('./pages/find-page')),
    layout: 'default',
    permissions: { scopes: ['find-users'] },
    menu: {
      title: 'pages.users.find.title',
    },
  },
  {
    id: 'user-detail',
    path: FIND_ROUTE_PATHS.userDetail,
    component: lazy(() => import('./pages/user-detail-page')),
    layout: 'default',
    permissions: { scopes: ['find-users'] },
  },
];
